import { T_MongoDoc, T_MongoId } from "../types/_utils.types";

export type LeadDto = {
  ray_id: string;
  name: string;
  email?: string;
  phone?: string;
  message?: string;
  debt_amount: number;
  meta_information: LeadMeta;
  questionaire?: LeadQuestionaire;
  address?: AddressInfo;
  status: LeadStatus;
  assigned_to?: T_MongoId; // reference to user of FCDS
  affiliate_manager?: T_MongoId;
  remarks?: string;
  logs: LeadLogs[] | [];
  applications?: ApplicationData[];
  affiliate?: T_MongoId;
};

type ApplicationData = {
  referrer_code?: string;
  app_key: string; // the app key of that application id in getclear db
  total_loans?: number;
  total_banks?: number;
  total_lawsuits?: number;
  enrolled_debt?: number;
  last_step?: string | "";
  onboarding_completed?: boolean;
  payments?: any[];
  plan?: {
    title: string;
    initial_payment: number;
    weekly_payment: number;
    tenure: number;
  };
};

export type LeadQuestionaire = {
  is_making_payments: MakingPayments;
  payment_amount: number;
  payment_frequency?: PaymentFrequency;
  has_pending_lawsuit?: PendingLawsuit;
};

export type LeadLogs = {
  message: string;
  timestamp: Date;
  status: LeadStatus;
  user?: string;
};

export type AddressInfo = {
  house_no?: string;
  street: string;
  second_line?: string;
  locality?: string;
  state: string;
  country: string;
  zipcode: number;
};

export type LeadMeta = {
  ip: string;
  location?: string;
  browser?: string;
  geo_loc?: string; // use if google maps is used
  local_time: Date;
  time_zone?: string;
};

export enum PaymentFrequency {
  MONTHLY = "Monthly",
  DAILY = "Daily",
  WEEKLY = "Weekly",
  QUARTERLY = "Quarterly",
  YEARLY = "Yearly",
}

export enum MakingPayments {
  YES = "Yes",
  NO = "No",
  SOMETIMES = "Sometimes",
}

export enum PendingLawsuit {
  YES = "Yes",
  NO = "No",
}

export enum LeadStatus {
  CREATED = "Created",
  OPEN = "Open",
  ASSIGNED = "Assigned",
  MEETING_PENDING = "Meeting Pending",
  MEETING_DONE = "Meeting Done",
  RESPONSE_AWAITED = "Response Awaited",
  CONVERTIBLE = "Potential",
  ONBOARDED = "Onboarded",
  CLOSED = "Closed",
}

export type LeadSchemaDto = LeadDto & T_MongoDoc;

export type CreateLeadDto = LeadDto;
export type UpdateLeadDto = Partial<LeadDto>;
